import { render, staticRenderFns } from "./manageCompany.vue?vue&type=template&id=0d3cd5b3&"
import script from "./manageCompany.vue?vue&type=script&lang=js&"
export * from "./manageCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports